import React from 'react'

type AppErrorBoundaryProps = {
  children: React.ReactNode
}

type AppErrorBoundaryState = {
  hasError: boolean
}

const authStorageKey = 'fieldpresence.auth.session'

export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    hasError: false,
  }

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    console.error('Portal runtime error:', error)
  }

  private recover = () => {
    window.localStorage.removeItem(authStorageKey)
    window.history.replaceState(null, '', '/login')
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    return (
      <main className="app-error-page" role="alert">
        <section className="app-error-card">
          <p>Erro do sistema</p>
          <h1>Não foi possível abrir a tela.</h1>
          <button type="button" className="auth-primary" onClick={this.recover}>
            Recuperar acesso
          </button>
        </section>
      </main>
    )
  }
}
